import request from '@/utils/request/index.js'

const tableName = 'prices'

// 获取数据列表
export function commonList (data) {
  data.table_name = tableName
  return request({
    url: 'front/common_list.php',
    method: 'post',
    data
  })
}

// 新增数据
export function commonAdd (data) {
  data.table_name = tableName
  return request({
    url: 'front/common_add.php',
    method: 'post',
    data
  })
}

// 编辑数据
export function commonEdit (data) {
  data.table_name = tableName
  return request({
    url: 'front/common_edit.php',
    method: 'post',
    data
  })
}

// 获取详情
export function commonDetail (data) {
  data.table_name = tableName
  return request({
    url: 'front/common_detail.php',
    method: 'post',
    data
  })
}
